'use client';
import { getCapabilitiesQueryOptions, } from '@wagmi/core/experimental';
import { useAccount } from '../../hooks/useAccount.js';
import { useConfig } from '../../hooks/useConfig.js';
import { useQuery } from '../../utils/query.js';
/** https://wagmi.sh/react/api/hooks/useCapabilities */
export function useCapabilities(parameters = {}) {
    const { account, query = {} } = parameters;
    const { address } = useAccount();
    const config = useConfig(parameters);
    const options = getCapabilitiesQueryOptions(config, {
        ...parameters,
        account: account ?? address,
    });
    return useQuery({ ...query, ...options });
}
//# sourceMappingURL=useCapabilities.js.map